module.exports = __webpack_public_path__ + "assets/fonts/arrow-left-1.2227c15b.svg";